export class RequestValid {
  isValid: boolean;
  object: string;
}
